// extracted by mini-css-extract-plugin
export default {"box":"common___box___f9b409fc","center":"common___center___b6ef6600","inputsRow":"common___inputsRow___b8f281fc","tip":"common___tip___d45bd80f"};